<div class="page-container">
  <div class="max-content-width spaced-sections">
    <div class="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h1 class="page-title">Initial system setup</h1>
        <p class="page-subtitle">Create the first administrator account for this environment.</p>
      </div>

      <a routerLink="/login" class="btn-secondary">Back to login</a>
    </div>

    <section class="card card-padding">
      @if (errorMessage) {
        <app-base-alert
          type="error"
          title="Setup problem"
          [message]="errorMessage"
          (closed)="clearError()"
        ></app-base-alert>
      }

      @if (successMessage) {
        <app-base-alert
          type="success"
          title="Setup complete"
          [message]="successMessage"
          [closeable]="false"
        ></app-base-alert>
      }

      <form [formGroup]="setupForm" (ngSubmit)="createSuperAdmin()" class="space-y-4">
        <div class="grid gap-4 sm:grid-cols-2">
          <div>
            <label for="setupFirstName" class="input-label">First name</label>
            <input
              id="setupFirstName"
              type="text"
              formControlName="firstName"
              class="input-field mt-1"
            />
            @if (submitted && setupForm.controls.firstName.errors?.required) {
              <p class="mt-1 text-xs text-red-700">First name is required.</p>
            }
          </div>

          <div>
            <label for="setupLastName" class="input-label">Last name</label>
            <input
              id="setupLastName"
              type="text"
              formControlName="lastName"
              class="input-field mt-1"
            />
            @if (submitted && setupForm.controls.lastName.errors?.required) {
              <p class="mt-1 text-xs text-red-700">Last name is required.</p>
            }
          </div>
        </div>

        <div>
          <label for="setupEmail" class="input-label">Email</label>
          <input id="setupEmail" type="email" formControlName="email" class="input-field mt-1" />
          @if (submitted && setupForm.controls.email.errors?.required) {
            <p class="mt-1 text-xs text-red-700">Email is required.</p>
          }
          @if (submitted && setupForm.controls.email.errors?.email) {
            <p class="mt-1 text-xs text-red-700">Enter a valid email address.</p>
          }
        </div>

        <div>
          <label for="setupAffiliation" class="input-label">Affiliation</label>
          <input
            id="setupAffiliation"
            type="text"
            formControlName="affiliation"
            class="input-field mt-1"
          />
        </div>

        <div class="grid gap-4 sm:grid-cols-2">
          <div>
            <label for="setupPassword" class="input-label">Password</label>
            <input
              id="setupPassword"
              type="password"
              autocomplete="new-password"
              formControlName="password"
              class="input-field mt-1"
            />
            @if (submitted && setupForm.controls.password.errors?.required) {
              <p class="mt-1 text-xs text-red-700">Password is required.</p>
            }
            @if (submitted && setupForm.controls.password.errors?.minlength) {
              <p class="mt-1 text-xs text-red-700">Password must be at least 8 characters.</p>
            }
          </div>

          <div>
            <label for="setupConfirmPassword" class="input-label">Repeat password</label>
            <input
              id="setupConfirmPassword"
              type="password"
              autocomplete="new-password"
              formControlName="confirmPassword"
              [class.border-red-300]="passwordsDoNotMatch"
              class="input-field mt-1"
            />
            @if (submitted && setupForm.controls.confirmPassword.errors?.required) {
              <p class="mt-1 text-xs text-red-700">Repeat the password.</p>
            }
            @if (passwordsDoNotMatch) {
              <p class="mt-1 text-xs text-red-700">Passwords do not match.</p>
            }
          </div>
        </div>

        <div class="flex justify-end gap-2 pt-2">
          <a routerLink="/profile" class="btn-secondary">Cancel</a>
          <button
            type="submit"
            [disabled]="saving"
            [className]="saving ? 'btn-disabled-primary' : 'btn-primary'"
          >
            {{ saving ? 'Creating...' : 'Create Super Admin' }}
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
